import { Globe } from "lucide-react";
import { useState } from "react";
import type { PublishingPlatform } from "~/core/api/distribution";

type PlatformMark = Pick<PublishingPlatform, "logo_url" | "domain">;

/** The platform's own mark, or a globe when it has none that loads. */
export function PlatformIcon({ platform }: { platform: PlatformMark | undefined }) {
	const [failed, setFailed] = useState(false);
	const src = platform?.logo_url || (platform?.domain ? `https://${platform.domain}/favicon.ico` : null);
	return src && !failed ? (
		<img
			className="platform-icon"
			src={src}
			alt=""
			loading="lazy"
			referrerPolicy="no-referrer"
			onError={() => setFailed(true)}
		/>
	) : (
		<Globe className="platform-icon" aria-hidden="true" />
	);
}

export function PlatformIdentity({ platform }: { platform: PublishingPlatform }) {
	return (
		<span className="platform-identity">
			<PlatformIcon platform={platform} />
			<span>{platform.name}</span>
		</span>
	);
}
